import React from 'react';
import SearchError from '../../common/search-error/search-error';
import { type ScreenSpecificProps } from '../product-router/product/result-provider/result-renderer/result-renderer-types';

export const SearchErrorScreen = ({
	onRetry = () => null,
}: Pick<ScreenSpecificProps, 'onRetry'>) => {
	return <SearchError onRetry={onRetry} />;
};
